import { ServiceResponse } from '@sdbn/common';
import { PageCall } from '@sdbn/tmc-common';
import { TransportOptionSelection } from '../../components/transport-options-panel/transport-options-panel.model';

export class TerminalTransportRegistration extends ServiceResponse {

  terminalIdentifier: string;
  planningDate: string;
  carrier: string;
  coDriver: string;
  driver: string;
  supplier: string;
  numberPlate: string;
  trailerNumberPlate: string;
  gcCaseId: string;
  gcCaseUrl: string;
  useGlobalConnect = false;
  useSms = false;
  messagingLanguage: string;
  messagingProvider: string;
  pageCalls = new Array<PageCall>();
  orderReference: string;
  phoneNumber: string;
  string1: string;
  string2: string;
  vehicleType: string;
  registrationId: number;
  registrationFinished: number;
  registrationStarted: number;
  selectedOptions = new Array<TransportOptionSelection>();
  targetStation?: number;
  smartphoneCommunicationEnabled: boolean;
  smartphoneConnected: boolean;
  smartphoneRequired: boolean;

  constructor(details?: Partial<TerminalTransportRegistration>) {
    super(details);
    if (details != null) {
      this.terminalIdentifier = details.terminalIdentifier;
      this.planningDate = details.planningDate;
      this.carrier = details.carrier;
      this.coDriver = details.coDriver;
      this.driver = details.driver;
      this.supplier = details.supplier;
      this.numberPlate = details.numberPlate;
      this.trailerNumberPlate = details.trailerNumberPlate;
      this.string1 = details.string1;
      this.string2 = details.string2;
      this.gcCaseId = details.gcCaseId;
      this.gcCaseUrl = details.gcCaseUrl;
      this.useGlobalConnect = details.useGlobalConnect === true;
      this.useSms = details.useSms === true;
      this.messagingLanguage = details.messagingLanguage;
      this.messagingLanguage = details.messagingLanguage;
      this.messagingProvider = details.messagingProvider;
      this.vehicleType = details.vehicleType;
      if (details.pageCalls) {
        for (const pageCall of details.pageCalls) {
          this.pageCalls.push(new PageCall(pageCall));
        }
      }
      this.orderReference = details.orderReference;
      this.phoneNumber = details.phoneNumber;
      this.registrationId = details.registrationId;
      this.registrationFinished = details.registrationFinished;
      this.registrationStarted = details.registrationStarted;
      if (details.selectedOptions != null) {
        for (const o of details.selectedOptions) {
          this.selectedOptions.push(new TransportOptionSelection(o));
        }
      }
      this.targetStation = details.targetStation;
      this.smartphoneCommunicationEnabled = details.smartphoneCommunicationEnabled;
      this.smartphoneConnected = details.smartphoneConnected;
      this.smartphoneRequired = details.smartphoneRequired;
    }
  }
}

export class TerminalTransportRegistrationResult extends ServiceResponse {

  numberPlate: string;
  trailerNumberPlate: string;
  registrationId: number;
  driver: string;
  coDriver: string;
  carrier: string;
  supplier: string;
  orderReference: string;
  registrationCode: string;
  gatekeeperMandatory: boolean;
  selectedOptions = new Array<TransportOptionSelection>();

  constructor(details?: Partial<TerminalTransportRegistrationResult>) {
    super(details);
    if (details != null) {
      this.carrier = details.carrier;
      this.coDriver = details.coDriver;
      this.driver = details.driver;
      this.supplier = details.supplier;
      this.numberPlate = details.numberPlate;
      this.trailerNumberPlate = details.trailerNumberPlate;
      this.orderReference = details.orderReference;
      this.registrationId = details.registrationId;
      this.registrationCode = details.registrationCode;
      this.gatekeeperMandatory = details.gatekeeperMandatory;
      if (details.selectedOptions != null) {
        for (const o of details.selectedOptions) {
          this.selectedOptions.push(new TransportOptionSelection(o));
        }
      }
    }
  }
}
